<sd-modal
  [brand]="brand()"
  [type]="_type"
  [clickToClose]="true"
  [backdrop]="true"
  [modalCustomClass]="'c__modal-aside ' + asideClass()"
  [modalCustomId]="asideId()"
  [(isOpened)]="isOpened"
  [disabledAnimation]="false"
  (isOpenedChange)="onOpenedChange()"
  [position]="modalPosition()"
>
  <div class="c__modal-wrapper {{noPadding() ? 'has-no-padding' : ''}}" sd-modal-body>
    <button sd-button-icon
      [isSmall]="true"
      (click)="onClickCloseBtn()"
      [size]="iconSize.small"
      [theme]="themesEnum.invert"
      class="c__close-button"
      icon="icon-cross"
    ></button>
    <ng-content />
  </div>
</sd-modal>
